export default "__VITE_ASSET__D4AYc_HX__"